/* ============================================================
   Fibrolab — el video de la descripción arranca solo, sin sonido

   Los <iframe> de YouTube que vienen dentro de la descripción del
   producto arrancan con el póster y el botón de play: hay que hacer
   clic para verlos. Este script los convierte en video que se
   reproduce solo, en silencio, cuando el cliente llega a esa altura
   de la ficha.

   Cómo funciona:
   · No se toca el HTML de la descripción -que además no admite <div>
     ni class= por el sanitizador del tema-. El script busca el iframe
     dentro de [data-fls-autovideo] y le reescribe la URL.
   · Los tres parámetros son obligatorios y ninguno es opcional:
     mute=1 (sin silencio NINGÚN navegador deja arrancar solo),
     playsinline=1 (sin esto iOS lo abre a pantalla completa encima de
     la ficha) y autoplay=1.
   · La carga se aplaza: el src se guarda y solo se inyecta cuando el
     video entra en pantalla. Así no se gasta el dato de nadie que no
     baje hasta ahí, y el video empieza cuando el cliente lo está
     mirando, no dos minutos antes.
   · Al salir de pantalla se pausa, y al volver se reanuda. Si una
     ficha tuviera dos videos, solo corre uno a la vez.
   · Sin botones: controls=0 quita la barra de reproducción, fs=0 el
     botón de pantalla completa, iv_load_policy=3 las tarjetas y rel=0
     los videos sugeridos del final. Además el iframe queda con
     pointer-events:none, que es lo que evita que YouTube saque la capa
     con el título y el "Ver en YouTube" al pasar el mouse.
     OJO: lo único que YouTube NO deja quitar es el nombre del canal
     que aparece arriba los primeros segundos. Taparlo con una capa
     encima va contra los términos de YouTube, así que no se hace.
   · Para un video SIN NADA -ni botones, ni logo, ni nombre de canal-
     el script también acepta un <video> con un MP4 subido a Shopify
     (Contenido → Archivos). Ahí no hay reproductor de terceros: es un
     video del sitio, arranca solo, en loop y sin un solo botón. Es lo
     que usan las tiendas donde viste el efecto.
   · Se respeta al que pidió «reducir movimiento» en su sistema o
     tiene el ahorro de datos del navegador: ahí no se toca nada.

   Si el navegador bloquea igual el autoplay -iOS en modo de bajo
   consumo, por ejemplo-, no pasa nada malo: queda el póster con el
   botón de play, que es exactamente lo que había antes.
   ============================================================ */
(function () {
  'use strict';

  var SELECTOR = '[data-fls-autovideo] iframe, [data-fls-autovideo] video';
  var VISIBLE = 0.4;          // cuánto del video tiene que verse para arrancar
  var reproductores = [];

  function ahorroDeDatos() {
    var c = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
    if (!c) return false;
    if (c.saveData) return true;
    return /(^|-)2g$/.test(c.effectiveType || '');
  }

  function menosMovimiento() {
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }

  function idDeYoutube(url) {
    var m = String(url || '').match(
      /(?:youtube(?:-nocookie)?\.com\/(?:embed|v)\/|youtu\.be\/)([\w-]{6,})/
    );
    return m ? m[1] : '';
  }

  function urlConAutoplay(src, id) {
    var partes = String(src).split('?');
    var q = new URLSearchParams(partes[1] || '');
    q.set('autoplay', '1');
    q.set('mute', '1');
    q.set('playsinline', '1');
    q.set('loop', '1');
    q.set('playlist', id);      // loop=1 no hace nada en un video suelto sin esto
    q.set('rel', '0');              // sin videos sugeridos de otros canales al final
    q.set('modestbranding', '1');
    q.set('controls', '0');         // fuera la barra de play, tiempo y volumen
    q.set('disablekb', '1');        // que el teclado no lo pause sin querer
    q.set('iv_load_policy', '3');   // fuera las anotaciones y tarjetas
    q.set('fs', '0');               // fuera el botón de pantalla completa
    q.set('enablejsapi', '1');  // hace falta para poder pausarlo al salir de pantalla
    q.set('origin', window.location.origin);
    return partes[0] + '?' + q.toString();
  }

  function mandar(iframe, funcion) {
    try {
      iframe.contentWindow.postMessage(
        JSON.stringify({ event: 'command', func: funcion, args: [] }),
        '*'
      );
    } catch (e) { /* el iframe todavía no está listo: se ignora */ }
  }

  function prepararMp4(el) {
    // Un <video> propio no necesita reproductor de nadie: se le fuerzan los
    // atributos que hacen falta y listo. Sin `controls` no hay un solo botón.
    var src = el.getAttribute('src') || (el.querySelector('source') || {}).src || '';
    if (!src) return null;
    el.muted = true;            // como propiedad, no solo como atributo:
    el.setAttribute('muted', '');  // Safari mira la propiedad para dejar arrancar
    el.loop = true;
    el.playsInline = true;
    el.setAttribute('playsinline', '');
    el.removeAttribute('controls');
    el.removeAttribute('autoplay');   // lo dispara el observer, no el navegador
    el.setAttribute('preload', 'none');
    el.style.pointerEvents = 'none';
    return { el: el, tipo: 'mp4', cargado: false };
  }

  function preparar(el) {
    if (el.tagName === 'VIDEO') return prepararMp4(el);
    var src = el.getAttribute('src') || '';
    var id = idDeYoutube(src);
    if (!id) return null;                       // Vimeo u otro: se deja como está
    var p = { el: el, tipo: 'youtube', url: urlConAutoplay(src, id), cargado: false };
    // Se le quita el src para que el navegador no lo cargue antes de tiempo.
    el.removeAttribute('src');
    el.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture; web-share');
    el.setAttribute('loading', 'lazy');
    // Sin puntero encima, YouTube no saca la capa de título ni el botón de
    // "Ver en YouTube" al pasar el mouse, y un clic por accidente no lo pausa.
    // El precio es que el cliente no puede activar el sonido: es la decisión
    // que se tomó al pedir "solo el video". Se revierte quitando esta línea.
    el.style.pointerEvents = 'none';
    return p;
  }

  function arrancar(p) {
    if (p.tipo === 'mp4') {
      if (!p.cargado) { p.el.setAttribute('preload', 'auto'); p.cargado = true; }
      var pr = p.el.play();
      // Si el navegador lo bloquea igual -iOS en bajo consumo-, se deja el
      // póster quieto en vez de reventar en la consola.
      if (pr && pr.catch) pr.catch(function () {});
      return;
    }
    if (!p.cargado) {
      p.el.setAttribute('src', p.url);          // al cargar con autoplay=1 ya parte solo
      p.cargado = true;
      return;
    }
    mandar(p.el, 'playVideo');
  }

  function pausar(p) {
    if (p.tipo === 'mp4') { if (p.cargado) p.el.pause(); return; }
    if (p.cargado) mandar(p.el, 'pauseVideo');
  }

  function buscar(el) {
    for (var i = 0; i < reproductores.length; i++) {
      if (reproductores[i].el === el) return reproductores[i];
    }
    return null;
  }

  function init() {
    var iframes = document.querySelectorAll(SELECTOR);
    if (!iframes.length) return;
    if (menosMovimiento() || ahorroDeDatos()) return;
    if (!('IntersectionObserver' in window)) return;

    Array.prototype.forEach.call(iframes, function (el) {
      var p = preparar(el);
      if (p) reproductores.push(p);
    });
    if (!reproductores.length) return;

    var obs = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (e) {
        var p = buscar(e.target);
        if (!p) return;
        if (e.isIntersecting) {
          reproductores.forEach(function (o) { if (o !== p) pausar(o); });
          arrancar(p);
        } else {
          pausar(p);
        }
      });
    }, { threshold: VISIBLE });

    reproductores.forEach(function (p) { obs.observe(p.el); });

    // Los paneles de la ficha son <details>. Uno cerrado no tiene alto, así
    // que el observer nunca dispara; cuando el cliente lo abre hay que volver
    // a medir. El evento 'toggle' no burbujea: se escucha en captura.
    document.addEventListener('toggle', function (ev) {
      if (!ev.target || ev.target.tagName !== 'DETAILS') return;
      reproductores.forEach(function (p) { obs.unobserve(p.el); obs.observe(p.el); });
    }, true);

    // Al volver a la pestaña, el video pausado por el navegador se reanuda solo
    // si sigue en pantalla; si no, se queda quieto.
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) reproductores.forEach(pausar);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
